<template>
  <div class="popupContent relative w-full h-full">
    <div class="banner_mask"></div>
    <img
      class="w-full h-full show-desktop-only"
      :class="callToActionLink && callToActionLink.length > 0 ? 'cursor-pointer' : ''"
      :src="imagePath"
      alt="banner"
      @click="bannerOnClick"
    />
    <div class="text-center">
      <img
        class="w-full show-mobile-only"
        :class="callToActionLink && callToActionLink.length > 0 ? 'cursor-pointer' : ''"
        :src="mobileImagePath"
        alt="banner"
        @click="bannerOnClick"
      />
    </div>
    <div
      v-if="isShowSnoozeCheckbox || abTestingTemplates.length > 0"
      class="absolute w-full z-2 bottom-[28px] md:bottom-[12px] flex flex-wrap xs:flex-nowrap justify-between items-end gap-1 px-5"
    >
      <div class="flex flex-col justify-start items-start text-start">
        <el-checkbox
          v-for="template in abTestingTemplates"
          :key="template.id"
          :value="template.checked"
          @change="checked => setAbTestingTemplate(template.id, checked)"
          class="w-auto m-0 flex items-center justify-end"
        >
          <span>{{ template.targetContentSetting }}</span>
        </el-checkbox>
      </div>
      <div class="text-end">
        <el-checkbox
          v-if="isShowSnoozeCheckbox"
          v-model="checked"
          class="w-auto m-0 flex items-center justify-end whitespace-nowrap"
        >
          <span>{{ $t('popupBanner.doNotShowThisAgain') }}</span>
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupContent',
  props: {
    imagePath: { type: String, default: '' },
    mobileImagePath: { type: String, default: '' },
    callToActionLink: { type: String, default: '' },
    addRemoveSnoozeBanner: { type: [Function, null], default: null },
    //  {
    //   id,
    //   templateName,
    //   targetAudienceType,
    //   displayPage,
    //   rules,
    //   campaignId,
    //   campaignName,
    //   targetContentSetting
    // }[]
    abTestingTemplates: { type: Array, default: [] },
    setAbTestingTemplate: { type: Function, default: () => {} }
  },
  data() {
    return { checked: false };
  },
  computed: {
    isShowSnoozeCheckbox() {
      return this.addRemoveSnoozeBanner !== null;
    }
  },
  watch: {
    checked(checked) {
      if (checked && this.addRemoveSnoozeBanner) {
        this.addRemoveSnoozeBanner('add');
      } else {
        this.addRemoveSnoozeBanner('remove');
      }
    }
  },
  methods: {
    bannerOnClick() {
      if (this.callToActionLink && this.callToActionLink.length > 0) {
        window.open('https://' + this.callToActionLink, '_blank');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.popupContent {
  position: relative;
  /deep/ {
    .el-checkbox .el-checkbox__label {
      width: auto;
      padding-left: 8px;
      color: $white;
    }
  }
  .banner_mask {
    position: absolute;
    width: 100%;
    height: 74px;
    background: linear-gradient(0deg, rgba(16, 19, 23, 0.45) 0%, rgba(255, 255, 255, 0) 100%);
    left: 0;
    bottom: 0;
    z-index: 1;
  }
}

.show-mobile-only {
  max-width: 500px;
}

.show-desktop-only {
  display: none;
}

@media screen and (min-width: 769px) {
  .show-mobile-only {
    display: none;
  }

  .show-desktop-only {
    display: block;
  }
}
</style>
